// extracted by mini-css-extract-plugin
export default {"error":"ConnectionLinkFolderModal_error__H-aQl"};